import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
var BrowserWarningComponent = /** @class */ (function () {
    function BrowserWarningComponent(translate, route) {
        if (translate === void 0) { translate = null; }
        this.translate = translate;
        this.route = route;
        this.currentBrowserClient = { name: '', version: '', release: '' };
        this.upgradeVersions = [
            { browser: 'Chrome', version: '75', release: '0' },
            { browser: 'Internet Explorer', version: '11', release: '557' },
            { browser: 'Safari', version: '12', release: '0' },
            { browser: 'Firefox', version: '66', release: '0' },
            { browser: 'Edge', version: '44', release: '177' }
        ];
    }
    BrowserWarningComponent.prototype.ngOnInit = function () {
        this.checkBrowser();
    };
    BrowserWarningComponent.prototype.checkBrowser = function () {
        var ua = navigator.userAgent;
        var tem;
        var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1]) || /MSI/i.test(M[1])) {
            var ie = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(ua);
            this.currentBrowserClient.name = 'IE';
            this.currentBrowserClient.version = (ie[2] || '0');
            return;
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                var auxTemp = tem.slice(1).join(' ').replace('OPR', 'Opera');
                var temp = auxTemp.split(' ')[0];
                this.handlerBrowser(temp);
                return;
            }
        }
        var MM = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            MM.splice(1, 1, tem[1]);
        }
        this.handlerBrowser(MM.toString().split(' ')[0]);
    };
    BrowserWarningComponent.prototype.fullVersion = function (str) {
        var parameter = str.split(',')[0];
        var ua = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i);
        if (parameter === 'Chrome') {
            return ua.input.substring(ua.input.indexOf(str.split(',')[0]), ua.input.substring(ua.input.indexOf(' '), ua.input.length).length - 3);
        }
        if (parameter === 'Edge' || parameter === 'Firefox' || parameter === 'Safari') {
            return ua.input.substring(ua.input.indexOf(parameter), ua.input.length);
        }
        else {
            return '0';
        }
    };
    BrowserWarningComponent.prototype.handlerBrowser = function (parameter) {
        var browserVersion = this.fullVersion(parameter);
        this.currentBrowserClient.name = browserVersion.split('/')[0];
        var tempVersion = browserVersion.split('/')[1];
        this.currentBrowserClient.version = tempVersion.split(' ')[0].split('.')[0];
        this.currentBrowserClient.release = tempVersion.split(' ')[0].split('.')[1];
    };
    BrowserWarningComponent.prototype.showWarningMessage = function (browser, version, release) {
        if (browser === 'IE' || browser === 'Edge') {
            return true;
        }
        var show = parseFloat(this.upgradeVersions.filter(function (item) { return item.browser === browser; })[0].version) > parseFloat(version)
            || (parseFloat(this.upgradeVersions.filter(function (item) { return item.browser === browser; })[0].version) > parseFloat(version)
                && parseFloat(this.upgradeVersions.filter(function (item) { return item.browser === browser; })[0].release)
                    <= parseFloat(release.slice(0, release.indexOf('.') - 1)));
        if (!show) {
            this.redirectRoot();
        }
        return show;
    };
    BrowserWarningComponent.prototype.redirectRoot = function () {
        this.route.navigate(['/']);
    };
    return BrowserWarningComponent;
}());
export { BrowserWarningComponent };
